import React, { ReactElement, useState, useEffect } from 'react'
import { Layout, Table, Space, BackTop, message, Tag } from "antd";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import firebase from "firebase/app";
import { ContentHeader } from "../../components/GlobalStyles";
import { getAuthState, getClubState } from "../../redux/selectors";
import { SET_LOADING_STATE, RESET_LOADING_STATE } from "../../redux/constants";

const { Content } = Layout;

export function Transactions(): ReactElement {

  const { currentUser } = useSelector(getAuthState);
  const { clubs } = useSelector(getClubState);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState<any[]>([]);
  const dispatch = useDispatch();
  // const { t } = useTranslation();
  // const dispatch = useDispatch();

  const getTransactionsByClub = async (clubId: string) => {
    dispatch({ type: SET_LOADING_STATE });
    try {
      const currentClub = clubs[0];
      const branchSnapshots = await firebase.firestore().collection("branches").where("club", "==", clubId).get();
      const branches = branchSnapshots.docs.map(doc => doc.data());
      const recordSnapshots = await firebase.firestore().collection("payment_history").where("clubId", "==", clubId).orderBy("timestamp", "desc").get();

      const transactions = recordSnapshots.docs.map(doc => {
        const { timestamp, ...data } = doc.data();
        const branch = branches.find(b => b.firestoreRef === data.branchId);
        const transaction = {
          ...data,
          createdAt: moment(timestamp.seconds * 1000).format("MMM DD, YYYY, H:mm A"),
          club: currentClub.name,
          branch: branch ? branch.location : "",
        }
        return transaction;
      })
      setRecords(transactions);
    } catch (e) {
      message.error("Oop! Something went wrong!");
    }
    dispatch({ type: RESET_LOADING_STATE });
  }

  const getTransactions = async () => {
    dispatch({ type: SET_LOADING_STATE });
    try {
      const recordSnapshots = await firebase.firestore().collection("payment_history").orderBy("timestamp", "desc").get();
      const transactions = await Promise.all(
        recordSnapshots.docs.map(async doc => {
          const { timestamp, ...data } = doc.data();
          const bookingClub = clubs.find(c => c.firestoreRef === data.clubId);
          const branchSnapshot = await firebase.firestore().collection("branches").doc(data.branchId).get();
          const branchData = branchSnapshot.data();
          const transaction = {
            ...data,
            createdAt: moment(timestamp.seconds * 1000).format("MMM DD, YYYY, H:mm A"),
            club: bookingClub?.name,
            branch: branchData?.location,
          }
          return transaction;
        })
      );
      setRecords(transactions);
    } catch (e) {
      message.error("Oop! Something went wrong!");
    }

    dispatch({ type: RESET_LOADING_STATE });
  }

  useEffect(() => {
    if (currentUser?.role === "admin") getTransactions();
    else if (currentUser?.role === "manager") getTransactionsByClub(currentUser?.club);
  }, [currentUser])

  const columns: any = [
    {
      title: "User Name",
      key: "name",
      dataIndex: "name"
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Amount",
      key: "amount",
      render: (record: any) => (<span>{record.amount}{record.currency}</span>)
    },
    {
      title: "Type",
      key: "type",
      render: (record: any) => (<span style={{ textTransform: "capitalize" }}>{record.paymentType}</span>)
    },
    {
      title: "Created At",
      key: "timestamp",
      dataIndex: "createdAt"
    },
    {
      title: "Club",
      key: "club",
      dataIndex: "club"
    },
    {
      title: "Branch",
      key: "branch",
      dataIndex: "branch"
    },
    {
      title: "Booking Date",
      key: "booking_date",
      dataIndex: "bookingDate"
    },
    {
      title: "Booking Time",
      key: "booking_time",
      render: (record: any) => {
        const date = moment(`${record.bookingDate} ${record.bookingTime}`).format("H:mm A");
        return (
          <span>{date}</span>
        )
      }
    },
    {
      title: "Status",
      key: "status",
      render: (record: any) => {
        let color;
        let text;
        switch (record.status) {
          case "processed":
            color = "#52c41a";
            text = "Success";
            break;
          case "failed":
            color = "#f50"
            text = "Failure";
            break;
          case "refunded":
            color = "#2db7f5";
            text = "Refunded";
            break;
          case "refund_fail":
            color = "#f50";
            text = "Refund Failure";
            break;
          default:
            color = "";
            text = "";
        }
        return <Tag color={color}>{text}</Tag>
      }
    }
  ];

  return (
    <Content>
      <BackTop />
      <ContentHeader>Transactions</ContentHeader>
      <Table columns={columns} dataSource={records} pagination={false} loading={loading} />
    </Content>
  )
}



